/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const maxMediaFileSizeKb = 51200 as const

export type MaxMediaFileSizeKb = typeof maxMediaFileSizeKb
